<template>
<div>
        <nav>
            <div class="navregular">
                <span>{{ this.$store.state.currentVersion }}</span>
                <router-link to="/">The Chinese Type Archive</router-link>
                <a></a>
            </div>
            <div class="navmobile">
                <router-link to="/records">View Records</router-link>
                <router-link to="/about">About the Archive</router-link>
                <span class="menubutton" @click="menuButtonClicked"></span>
            </div>
        </nav>

        <header>
            <div>
                <h2 class="header_main_eng">{{ totalitemcount }} Indexed Items</h2>
                <h2 class="header_main_ch">索引</h2>
            </div>
            <div :class="['subnav', sortByEng ? 'subnav_selected' : '']" @click="sortToggle(1)">
                <p class="header_main_eng">A&ndash;Z</p>
            </div>
            <div :class="['subnav', !sortByEng ? 'subnav_selected' : '']" @click="sortToggle(2)">
                <p class="header_main_ch">排序</p>
            </div>
        </header>
        <section class="mainbody">

            <div v-if="!this.$store.state.fetchedData" class="indexlist_envelope" lang="zh"><div class="loading-box"><div></div></div></div>
            <div v-else class="indexlist_envelope" lang="zh">
                <div v-for="(item, index) in (sortByEng ? combinedRecordsSortedEng : combinedRecordsSortedCh)" :key="item.key" class="indexlist_item" @click="goToRecord(item.type, item.recordid)">
                    <p class="indexlist_itemno">{{ ++index }}</p>
                    <p class="indexlist_ch">{{ item.namech }}</p>
                    <p class="indexlist_eng">{{ item.nameeng }}</p>
                </div>        
            </div>

        </section>
</div>
</template>

<script>
import router from '@/router'
import { mapGetters } from 'vuex'


export default {
    data(){
        return {
            sortByEng: true //If true, sort by eng; if flase, sort by ch
        }
    },
    computed: {
    ...mapGetters({
        recordscombined: 'recordsCombined',
        combinedrecords: 'combinedRecords',
        combinedRecordsSortedEng: 'combinedRecordsSortedEng',
        combinedRecordsSortedCh: 'combinedRecordsSortedCh'
    }),
    totalitemcount: function(){
        return this.combinedrecords.length
    }
  },
  methods: {
    goToRecord(recordtype,recordid){
        router.push(`/records/` + recordtype + `/` + recordid, () => {}) 
    },
    menuButtonClicked(){
      if(this.$store.state.menuOpened){
        this.$store.state.menuOpened=false;
      }else {
        this.$store.state.menuOpened=true;
      }
    },
    sortToggle(buttonclicked){
        //2 is the chinese sort button
        if(this.sortByEng && buttonclicked==2){
            this.sortByEng = false
        }
        //1 is the english sort button
        if(!this.sortByEng && buttonclicked==1){
            this.sortByEng = true
        }
    }
  }
}
</script>

<style>
</style>